import Modal from '../../../../../components/Modal'
import MDInput from '../../../../../components/MDComponents/MDInput'
import Button from '../../../../../components/Button'
import Multiselect from 'multiselect-react-dropdown'
import MDTypography from '../../../../../components/MDComponents/MDTypography'
import { titleCase } from 'utils'
import { settings } from 'settings'

const EditGeneralDataModal = ({
  isOpen,
  profileDataForModal,
  remainedUniversities,
  handleInput,
  setIsGeneralModalOpen,
  handleUpdateData,
  isSaveButtonDisabled,
  handleUniversitiesChange,
  error,
}) => {
  const { name, email, phone, uniList, nickname, account_type } =
    profileDataForModal
  return (
    <Modal
      closeModal={() => setIsGeneralModalOpen(false)}
      title="Editeaza detalile generale"
      isOpen={isOpen}
    >
      <div className="flex flex-col gap-5 relative">
        <form
          onSubmit={handleUpdateData}
          onChange={handleInput}
          className="grid  grid-cols-1 sm:grid-cols-2 mb-10  gap-10 lg:grid-cols-3 mt-8"
        >
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1">
              <span className="text-gray-500 font-bold text-xs">TIP CONT</span>
              <span className="font-bold text-over-primary-background text-sm">
                {account_type}
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-gray-500 font-bold text-xs">
                Referral Code
              </span>
              <span className="font-bold text-over-primary-background text-sm">
                -
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-gray-500 font-bold text-xs">
                {titleCase(settings.objective_articulated)} dorită
              </span>
              <span className="font-bold text-over-primary-background text-sm">
                <Multiselect
                  style={{
                    selectContainer: {
                      backgroundColor: 'red',
                    },
                    optionContainer: {
                      backgroundColor: 'rgb(var(--secondary-background))',
                      color: 'rgb(var(--over-secondary-background))',
                    },

                    searchBox: {
                      border: 'none',
                    },
                    chips: {
                      backgroundColor: 'rgb(var(--ternary))',
                    },
                  }}
                  className="border rounded border-brd-primary text-red-500 !max-w-64 !min-w-64  text-sm bg-container-background text-over-ternary-background"
                  options={remainedUniversities}
                  selectedValues={uniList}
                  onRemove={handleUniversitiesChange}
                  onSelect={handleUniversitiesChange}
                  closeOnSelect={true}
                  displayValue="short_name"
                  placeholder={titleCase(settings.objective)}
                />
              </span>
            </div>
          </div>
          <div className="flex flex-col justify-between gap-3">
            <div className="flex flex-col gap-1">
              <span className="text-gray-500 font-bold text-xs">NICKNAME</span>
              <span className="font-bold text-over-primary-background text-sm">
                {nickname}
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-gray-500 font-bold text-xs">EMAIL</span>
              <span className="font-bold text-over-primary-background text-sm">
                {email}
              </span>
            </div>
          </div>
          <div className="flex flex-col justify-between gap-3">
            <div className="flex flex-col gap-1">
              <span className="text-gray-500 font-bold text-xs">NUME</span>
              <MDInput
                value={name}
                type="name"
                name="name"
                variant="standard"
                fullWidth
                inputProps={{ style: { fontSize: 16 } }}
              />
              {error.name ? (
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="light"
                >
                  Numele nu poate fi gol
                </MDTypography>
              ) : null}
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-gray-500 font-bold text-xs">
                NR.TELEFON
              </span>
              <MDInput
                name="phone"
                value={phone}
                type="phone"
                variant="standard"
                fullWidth
                inputProps={{ style: { fontSize: 16 } }}
              />
            </div>
          </div>
          <div className="w-full flex mt-7 absolute -bottom-2 justify-end">
            <Button
              disabled={isSaveButtonDisabled}
              type="submit"
              className="bg-btn-primary w-32"
            >
              Salvează
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default EditGeneralDataModal
